// eslint-disable-next-line import/prefer-default-export
export const dummyChartData = {
  metric: '',
  alias: '',
  current: 100,
  new: 120,
  change_abs: 0,
  change_perc: 0,
  toggle: 'UNIT'
};
